import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import logoWhite from "@/assets/logo-corre-digital-white.png";

export default function AlunoLanding() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-hero flex flex-col">
      {/* Hero Section */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 text-center">
        <motion.img
          src={logoWhite}
          alt="Corre Digital"
          className="h-14 mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="space-y-4 max-w-sm"
        >
          <h1 className="font-heading text-3xl font-bold text-primary-foreground leading-tight">
            Sua trajetória começa aqui
          </h1>
          <p className="text-primary-foreground/80 text-lg">
            Mostre quem você é, não só o que você fez. Construa seu perfil, aprenda e conquiste oportunidades reais.
          </p>
        </motion.div>

        {/* Features */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-10 space-y-3 w-full max-w-sm"
        >
          {[
            "Cadastro em menos de 1 minuto",
            "Perfil que evolui com você",
            "Vagas de entrada sem exigir experiência",
          ].map((feature, i) => (
            <div
              key={i}
              className="flex items-center gap-3 bg-primary-foreground/10 rounded-xl px-4 py-3"
            >
              <Sparkles className="w-5 h-5 text-accent shrink-0" />
              <span className="text-primary-foreground text-sm font-medium">
                {feature}
              </span>
            </div>
          ))}
        </motion.div>
      </div>

      {/* CTA Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="px-6 pb-10 space-y-4"
      >
        <Button
          variant="hero-accent"
          size="xl"
          className="w-full"
          onClick={() => navigate("/aluno/escolha")}
        >
          Entrar no Banco de Talentos
          <ArrowRight className="w-5 h-5" />
        </Button>

        <p className="text-center text-primary-foreground/60 text-xs">
          Sem promessas falsas. Você evolui no seu ritmo.
        </p>
      </motion.div>
    </div>
  );
}
